import { render, staticRenderFns } from "./payRecord.vue?vue&type=template&id=6a83f35e&scoped=true"
import script from "./payRecord.vue?vue&type=script&lang=js"
export * from "./payRecord.vue?vue&type=script&lang=js"
import style0 from "./payRecord.vue?vue&type=style&index=0&id=6a83f35e&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a83f35e",
  null
  
)

export default component.exports